import type {IntlShape} from 'react-intl';

/** The template name the save modal starts with: "{project} — from {client}", or the project name alone. */
export const defaultTemplateName = (
	intl: IntlShape,
	projectName: string | null | undefined,
	clientName: string | null | undefined
): string => {
	const project = (projectName ?? '').trim();
	const client = (clientName ?? '').trim();
	return client ? intl.formatMessage({id: 'baseline_templates.save.default_name'}, {project, client}) : project;
};
